import { Fragment, useEffect, useState } from 'react';
import LoyaltyTicket from './LoyaltyTicket';
import LoyaltyText from './LoyaltyText';
import { getRewardImage } from '../../helpers/loyaltyHelpers';
import chevronLeft from '../../img/icons/ChevronLeft.svg';
import chevronRight from '../../img/icons/ChevronRight.svg';
import { useSelector } from 'react-redux';
import beer from './../../img/loyalty/wizard/beer.svg';
import cocktail from './../../img/loyalty/wizard/cocktail.svg';
import coffee from './../../img/loyalty/wizard/coffee.svg';
import cookbook from './../../img/loyalty/wizard/cookbook.svg';
import deliveryAndCollection from './../../img/loyalty/wizard/delivery & collection.svg';
import dolcetti from './../../img/loyalty/wizard/dolcetti.svg';
import doughballs from './../../img/loyalty/wizard/doughballs.svg';
import familyBundle from './../../img/loyalty/wizard/family bundle.svg';
import generic from './../../img/loyalty/wizard/generic.svg';
import hearts from './../../img/loyalty/wizard/hearts.svg';
import jazz from './../../img/loyalty/wizard/jazz.svg';
import kids1 from './../../img/loyalty/wizard/kids 1.svg';
import pizza1 from './../../img/loyalty/wizard/pizza 1.svg';
import pizza2 from './../../img/loyalty/wizard/pizza 2.svg';
import pizza3 from './../../img/loyalty/wizard/pizza 3.svg';
import pizza4 from './../../img/loyalty/wizard/pizza 4.svg';
import pizzaSlice1 from './../../img/loyalty/wizard/pizza slices 1.svg';
import pizzaSlice2 from './../../img/loyalty/wizard/pizza slices 2.svg';
import present from './../../img/loyalty/wizard/present.svg';
import side from './../../img/loyalty/wizard/side.svg';
import softDrink from './../../img/loyalty/wizard/soft drink.svg';
import special1 from './../../img/loyalty/wizard/special 1.svg';
import special2 from './../../img/loyalty/wizard/special 2.svg';
import special3 from './../../img/loyalty/wizard/special 3.svg';
import water from './../../img/loyalty/wizard/water.svg';
import wineGlass from './../../img/loyalty/wizard/wine glass.svg';
import wine from './../../img/loyalty/wizard/wine.svg';
import dip from './../../img/loyalty/wizard/dip.svg';

const imageLookup = {
  ['beer'] : beer,
  ['cocktail'] : cocktail,
  ['coffee'] : coffee,
  ['cookbook'] : cookbook,
  ['delivery & collection'] : deliveryAndCollection,
  ['dolcetti'] : dolcetti,
  ['doughballs'] : doughballs,
  ['family bundle'] : familyBundle,
  ['generic'] : generic,
  ['hearts'] : hearts,
  ['jazz'] : jazz,
  ['kids 1'] : kids1,
  ['pizza 1'] : pizza1,
  ['pizza 2'] : pizza2,
  ['pizza 3'] : pizza3,
  ['pizza 4'] : pizza4,
  ['pizza slices 1'] : pizzaSlice1,
  ['pizza slices 2'] : pizzaSlice2,
  ['present'] : present,
  ['side'] : side,
  ['soft drink'] : softDrink,
  ['special 1'] : special1,
  ['special 2'] : special2,
  ['special 3'] : special3,
  ['water'] : water,
  ['wine glass'] : wineGlass,
  ['wine']: wine,
  ['dip']: dip
};

const LoyaltyTicketCard = ({
  sectionIndex,
  isDisabled,
  onTicketClick,
  subHeading,
  data: {
    title,
    designOfTile,
    missingText,
    subSections,
    readOnly,
    selectionComplete,
    tags,
    thirdPartyRewardTypeId
  },
  tierName,
  index,
  setActiveIndex,
  colourInverted,
  cardCount,
  indicator,
  cardDisplay,
  updating,
  rewardsInfo
}) => {
  const rewardImage = getRewardImage(designOfTile);
  const { inApp } = useSelector(state => state.session);
  const [prevCompletionState, setPrevCompletionState] = useState(selectionComplete);
  const rewardInfo = rewardsInfo?.find(r => r.rewardDetails?.thirdPartyRewardTypeId === thirdPartyRewardTypeId);
  const tier = rewardInfo?.tierName ? rewardInfo.tierName === 'SignUp' ? 'Club Member' : rewardInfo.tierName : tierName === 'SignUp' ? 'Club Member' : tierName;

  let rewardImageAsset = null;
  try {
    rewardImageAsset = imageLookup[rewardImage.image];
  }
  catch {
    console.warn('Unable to load ticket card image');
  }

  useEffect(() => {
    const isCompleted = subSections.flatMap(el => el.offers).every(el => el.groupComplete);
    if (isCompleted && isCompleted !== prevCompletionState && subSections?.length) {
      setTimeout(() => setActiveIndex(index + 1), 400)
    }
    setPrevCompletionState(isCompleted);
  }, [subSections])

  return (
    <>
      <div className="card-container">
        <div style={{ borderRadius: 16, backgroundColor: 'rgba(255,255,255)' }}>
          {
            inApp &&
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', paddingTop: '1rem', opacity: isDisabled && inApp && 0.56 }}>
              <img
                onClick={() => {
                  setActiveIndex(index - 1);
                }}
                style={{ cursor: 'pointer', opacity: index === 0 ? 0 : 1, width: 24 }}
                src={chevronLeft}

              />

              <p style={{fontSize: '0.75rem', fontWeight: inApp ? '700' : '400'}} className='dm-sans'>{index + 1}/{indicator === 0 ? 1 : indicator}</p>

              <img
                onClick={() => {
                  setActiveIndex(index + 1);
                }}
                src={chevronRight}
                style={{ cursor: 'pointer', opacity: index === (cardCount - cardDisplay) || cardCount === 1 ? 0 : 1, width: 24 }}
              />
            </div>
          }
          <div className="voucher-card card-header-top" style={{ opacity: isDisabled && inApp && 0.56 }}>
            {title && <div className="content title-content">
              <h3 className="title is-3" style={{ wordBreak: 'keep-all' }}>
                <LoyaltyText text={title} />
              </h3>
              {tags.includes('BOOSTEROFFER')
                ? <p style={{ fontSize: '0.75rem', WebkitLineClamp: 3, marginBottom: 0 }}>Exclusive Offer</p>
                : <p style={{ fontSize: '0.75rem', WebkitLineClamp: 3, marginBottom: 0 }}>{tier} Reward</p>
              }
              {
                subHeading && <p style={{ fontSize: '0.75rem', WebkitLineClamp: 3 }}>{subHeading}</p>
              }
            </div>}
            {rewardImageAsset && <img src={rewardImageAsset} className='apply-rewards-image' />}
          </div>
          {
            subSections?.length ?
              <div style={{ display: 'flex', flexDirection: 'column', maxHeight: inApp ? '30vh' : null, overflowY: 'auto' }}>
                {subSections?.map((subSection, i) => {
                  return (<Fragment key={`subsection=${i}`}>
                    <div className={`voucher-card card-header-description ${subSection.displayTitle ? '' : 'remove-divider'}`}>
                      {subSection.displayTitle && subSection.title}
                      {inApp && title == 'Free Delivery' && <p>Reward will be applied at checkout</p>}
                    </div>

                    {subSection.offers.map((offer, i) =>
                      <LoyaltyTicket
                        key={`LoyaltyTicket-${i}`}
                        sectionIndex={sectionIndex}
                        isDisabled={isDisabled || updating || (offer.selected && !offer.selectedByThisUser) || offer.disabled || readOnly}
                        onTicketClick={onTicketClick}
                        offer={offer}
                        lastItem={(subSection.offers.length - 1) == i}
                        tierName={tierName}
                        inApp={inApp}
                      />)}
                  </Fragment>);
                }
                )}
              </div>
              :
              <></>
          }
          {subSections?.length === 0 &&
            <>
              <div className="card-parent">
                <div id="div4-id" className={'voucher-card ticket-container card-no-order card1'}>
                  <div className="ticket-container-inner empty">
                    <div className="card-content">
                      <p style={inApp ? { fontSize:'14px',lineHeight:'140%'} : {}} className='dm-sans'>{missingText}</p>
                    </div>
                  </div>
                </div>
              </div>
            </>}
        </div>
      </div>
    </>
  );
};

export default LoyaltyTicketCard;
